import { OcrBuilder } from 'types'

import { get } from './fetch'

const END_POINT = 'ocrbuilders'
export const OCRBUILDERS_CACHE_ID = 'ocrbuilerscacheid'

export async function getOcrBuilders() {
  const { results } = await (get(END_POINT, {
    cache: true,
    id: OCRBUILDERS_CACHE_ID,
  }) as Promise<{
    results: OcrBuilder[] | null
  }>)
  return results || []
}
